import { combineReducers } from 'redux';
import game from './matchio_red';

export default combineReducers({
  game
});
